<template>
  <OnBoardingFrame :error="errorMessage" :notice="noticeMessage">
    <!-- Shown after an email sign-up. The account is ready and usable now; the
         verification email (already sent server-side) is something to do
         whenever suits, not a gate. So it leads with "ready", says the email
         was sent rather than asking for an action to get it, and keeps resend
         as a quiet fallback. The mailbox buttons are shortcuts to the email
         that has already been sent, below the copy that says so. -->
    <div class="ob-center">
      <span class="ob-center__icon"><span class="ms fill" aria-hidden="true">check_circle</span></span>
      <h2 id="onBoardingTitle" class="ob-title">{{ $t('on_boarding.verify_email_page.your_account_is_ready') }}</h2>
      <p class="ob-center__text verify-email-body">
        <template v-if="email">
          <i18n-t keypath="on_boarding.verify_email_page.verification_sent_to_email" scope="global">
            <template #email><strong>{{ email }}</strong></template>
          </i18n-t>
        </template>
        <template v-else>
          {{ $t('on_boarding.verify_email_page.verification_sent') }}
        </template>
      </p>
    </div>

    <OpenMailboxButtons class="ob-mail" />

    <p class="ob-small verify-email-resend">
      {{ $t('on_boarding.verify_email_page.cant_find_it') }}
      <button type="button" class="ob-inline-link" :disabled="resending" @click="resend">
        {{ resending ? $t('on_boarding.verify_email_page.sending') : $t('on_boarding.verify_email_page.send_it_again') }}
      </button>
    </p>

    <template #footer>
      <button type="button" class="ob-btn ob-btn-primary" @click="continueTapped">
        {{ $t('on_boarding.verify_email_page.continue_to_hiiker') }}
      </button>
    </template>
  </OnBoardingFrame>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import OpenMailboxButtons from '../../../utils/shared_components/OpenMailboxButtons.vue';
import OnBoardingFrame from './OnBoardingFrame.vue';

export default defineComponent({
  name: 'OnBoardingVerifyEmailPage',
  components: { OnBoardingFrame, OpenMailboxButtons },
  data() {
    return {
      resending: false,
    };
  },
  computed: {
    email(): string | null {
      return this.$store.state.onBoarding.verifyEmailAddress;
    },
    errorMessage(): string | null {
      return this.$store.state.onBoarding.errorMessage;
    },
    noticeMessage(): string | null {
      return this.$store.state.onBoarding.noticeMessage;
    },
  },
  methods: {
    continueTapped() {
      this.$store.commit('onBoarding/setError', null);
      this.$store.commit('onBoarding/setNotice', null);
      this.$store.dispatch('onBoarding/setNextPostLoginPage');
    },
    async resend() {
      // Guard against double-taps hammering the send endpoint (Airship/rate limits).
      if (this.resending) return;
      this.resending = true;
      try {
        await this.$store.dispatch('onBoarding/resendVerificationEmail');
      } finally {
        // Brief cooldown so the link can't be spammed.
        setTimeout(() => { this.resending = false; }, 4000);
      }
    },
  },
  beforeUnmount() {
    this.$store.commit('onBoarding/setError', null);
    this.$store.commit('onBoarding/setNotice', null);
  },
});
</script>
